import config from "../temp/config";

export default {
  sitecoreHost: `${config.sitecoreApiHost || ""}`,
  apiBaseUrl: `${config.sitecoreApiHost || ""}/webapi/portalthird`,
  dictionaryUrl: `${config.sitecoreApiHost || ""}/sitecore/api/jss/dictionary/${config.jssAppName}/${
    config.defaultLanguage
  }?sc_apikey=${config.sitecoreApiKey}`,
};
